export default __webpack_public_path__ + "static/media/Golos Text_Black.e7b5510d.eot";